import { render, staticRenderFns } from "./StepQuizSelect.vue?vue&type=template&id=64e36afc&scoped=true&lang=pug"
import script from "./StepQuizSelect.vue?vue&type=script&lang=ts"
export * from "./StepQuizSelect.vue?vue&type=script&lang=ts"
import style0 from "./StepQuizSelect.vue?vue&type=style&index=0&id=64e36afc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e36afc",
  null
  
)

export default component.exports